import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  FormControl,
  TextField,
  Divider,
  Paper,
  MenuItem,
  MenuList,
  Tooltip,
  FormHelperText,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import Swal from 'sweetalert2';
import './styles/dialog.css';
import './styles/devicesview.css';
import { withTranslation } from 'react-i18next';
import * as Icons from '@material-ui/icons';
import { KeyboardArrowDown, LinkOff, HowToReg } from '@material-ui/icons';
import deburr from 'lodash/deburr';
import config from '../../config';
import TableCell from '@material-ui/core/TableCell';

export class ManageGarminAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      account: '',
      accountId: null,
      displayAccounts: false,
      errorField: {
        account: {
          flag: false,
          msg: '',
        },
      },
    };
  }

  validateAuthen = async (accountId, account) => {
    const { t, pathName } = this.props;
    try {
      const result = await this.props.smartwatch.testAuthenForAccount(accountId);
      if (result.statusCode === 200) {
        return true;
      }
    } catch (e) {
      if (e.statusCode === 401) {
        Swal.fire({
          html: `<h4>${t('authentication_expired')}`,
          icon: 'warning',
          type: 'warning',
          confirmButtonText: `${t('ok')}`,
          cancelButtonText: `${t('cancel')}`,
          showCancelButton: true,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            // encode account with Base64
            const garminAccount = btoa(account);
            const encodePathName = btoa(pathName);
            const host = window.location.host;
            const callbackUrl = `${config.protocol}://${host}/smartwatch/update/${accountId}/${garminAccount}/${encodePathName}`;
            const data = await this.props.garmin.getAccessLink(callbackUrl);
            if (data && data.url) {
              window.location.assign(data.url);
            }
          }
        });
      } else {
        Swal.fire({
          html: `<h4>${e.error.message}`,
          icon: 'error',
          type: 'error',
          customClass: {
            container: 'my-swal',
          },
        });
      }
      return false;
    }
  };

  validateEmail(email) {
    if (!email) return { flag: false, msg: '' };

    const regx = new RegExp(
      '^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    );

    if (!regx.test(email)) {
      const errInvalidField = 'this_field_is_invalid';
      this.setState({
        errorField: {
          account: {
            flag: true,
            msg: errInvalidField,
          },
        },
      });
      return false;
    } else {
      const { smartWatchAccounts } = this.props.smartwatch.toJS();
      const emailValue = deburr(email.trim()).toLowerCase();
      const fountAccount = (smartWatchAccounts || []).find((a) => a.username === emailValue);
      if (fountAccount) {
        const { t } = this.props;
        Swal.fire({
          html: `<h4>${t('account_is_already_exist')}`,
          icon: 'warning',
          type: 'warning',
          customClass: {
            container: 'my-swal',
          },
        });

        return false;
      } else {
        this.setState({
          errorField: {
            account: {
              flag: false,
              msg: '',
            },
          },
        });
        return true;
      }
    }
  }

  onAssignAccount = async (patient) => {
    const { accountId, account } = this.state;
    try {
      if (accountId) {
        const isAuth = await this.validateAuthen(accountId, account);
        if (isAuth) {
          const result = await this.props.smartwatch.assignPatientAccount(patient.id, accountId);
          if (result.statusCode === 200) {
            await this.props.smartwatch.getAccountByPatientId(patient.id);
            const queryOption = {
              patient: true,
              device: true,
            };
            await this.props.smartwatch.getAllAccounts(queryOption);
            this.setState({ account: '', accountId: null });
          }
        }
      } else {
        if (this.validateEmail(account)) {
          // encode account with Base64
          const garminAccount = btoa(account);
          const encodePathName = btoa(this.props.pathName);
          const host = window.location.host;
          const callbackUrl = `${config.protocol}://${host}/smartwatch/create/${patient.id}/${garminAccount}/${encodePathName}/${patient.tenantId}`;
          const data = await this.props.garmin.getAccessLink(callbackUrl);
          if (data && data.url) {
            window.location.assign(data.url);
          }
        }
      }
    } catch (e) {
      Swal.fire({
        html: `<h4>${e.error.message}`,
        icon: 'error',
        type: 'error',
        confirmButtonColor: '#007D79',
        customClass: {
          container: 'my-swal',
        },
      });
    }
  };

  onUnAssignAccount = async (patient) => {
    try {
      await this.props.smartwatch.unAssignPatientAccount(patient.id);
      const queryOption = {
        patient: true,
        device: true,
      };
      await this.props.smartwatch.getAllAccounts(queryOption);
      this.setState({ account: '', accountId: null, authenMessage: '' });
    } catch (e) {
      console.log('error: ', e.error.message);
    }
  };

  onClickTestAuthen = async (account) => {
    const { t, pathName } = this.props;
    const accountId = account ? account[0] : null;
    try {
      const result = await this.props.smartwatch.testAuthenForAccount(accountId);
      if (result.statusCode === 200) {
        Swal.fire({
          html: `<h4>${t('authentication_valid')}`,
          icon: 'success',
          type: 'success',
          customClass: {
            container: 'my-swal',
          },
        });
      }
    } catch (err) {
      if (err.statusCode === 401) {
        Swal.fire({
          html: `<h4>${t('authentication_expired')}`,
          icon: 'warning',
          type: 'warning',
          confirmButtonText: `${t('ok')}`,
          cancelButtonText: `${t('cancel')}`,
          showCancelButton: true,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            const username = account ? account[1] : null;
            // encode account with Base64
            const garminAccount = btoa(username);
            const encodePathName = btoa(pathName);
            const host = window.location.host;
            const callbackUrl = `${config.protocol}://${host}/smartwatch/update/${accountId}/${garminAccount}/${encodePathName}`;
            const data = await this.props.garmin.getAccessLink(callbackUrl);
            if (data && data.url) {
              window.location.assign(data.url);
            }
          }
        });
      } else {
        Swal.fire({
          html: `<h4>${err.error.message}`,
          icon: 'error',
          type: 'error',
          customClass: {
            container: 'my-swal',
          },
        });
      }
    }
  };

  onClickDropdown = async () => {
    this.setState({ displayAccounts: !this.state.displayAccounts });
  };

  onFocusTextField = async () => {
    this.setState({ displayAccounts: true });
  };

  handleChangeAccount = async (e) => {
    let { name, value } = e.target;
    this.clearErrorField(name);
    this.setState({ [name]: value, accountId: null });
  };

  clearErrorField(key) {
    if (key === 'account') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          account: {
            flag: false,
            msg: '',
          },
        },
      });
    }
  }

  handleSelect = (account) => {
    if (account) {
      this.setState({
        displayAccounts: false,
        account: account.username,
        accountId: account.id,
      });
    }
  };

  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  getGarminDeviceInfo = (devices) => {
    let info = '';
    (devices || []).forEach((d) => {
      info = info.length > 0 ? info + `, ${d.serial}` : d.serial;
    });
    return info;
  };

  render() {
    const { t, classes, handleClose, open } = this.props;
    const { account, displayAccounts } = this.state;
    const { smartWatchAccounts, accountPatient } = this.props.smartwatch.toJS();
    const patient = this.props.data ? this.props.data.patient : this.props.patientData;
    const fullname = this.getFullname(localStorage.getItem('i18nextLng'), patient);

    let accountList = smartWatchAccounts;
    if (account) {
      const inputValue = deburr(account.trim()).toLowerCase();
      accountList = accountList.filter((a) => {
        if (a.username && a.username.toLowerCase().includes(inputValue)) {
          return true;
        } else if (a.devices && a.devices.length > 0) {
          const found = a.devices.find((device) => {
            return device.serial.toLowerCase().includes(inputValue);
          });
          return found;
        }
        return false;
      });
    }

    const columns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          display: false,
        },
      },
      {
        name: 'username',
        label: `${t('username')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const devices = tableMeta.rowData && tableMeta.rowData[3];
            const username = tableMeta.rowData && tableMeta.rowData[1];
            return (
              <div>
                {devices && Array.isArray(devices) && devices.length > 0
                  ? username + ` (${this.getGarminDeviceInfo(devices)})`
                  : username}
              </div>
            );
          },
        },
      },
      {
        name: 'options',
        label: `${t('options')}`,
        options: {
          filter: false,
          customHeadRender: (columnMeta, updateDirection) => (
            <TableCell key={2} align='center'>
              {t('options')}
            </TableCell>
          ),
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={this.props.classes.columnWidth200}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Tooltip title={t('test_smartwatch_account')} classes={{ tooltip: classes.tooltip }}>
                    <HowToReg
                      style={{ cursor: 'pointer' }}
                      className={classes.icon}
                      onClick={() => this.onClickTestAuthen(row)}
                      id='testAuthen'
                    />
                  </Tooltip>
                  <Tooltip title={t('unassign')} classes={{ tooltip: classes.tooltip }}>
                    <LinkOff
                      style={{ cursor: 'pointer' }}
                      className={classes.icon}
                      onClick={() => this.onUnAssignAccount(patient)}
                      id='unassign'
                    />
                  </Tooltip>
                </div>
              </div>
            );
          },
        },
      },
      {
        name: 'devices',
        label: `${t('device')}`,
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
    ];

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' onClose={handleClose} id='form-dialog-title'>
          <Grid container style={{ position: 'relative' }}>
            <div>
              {t('manage_garmin_account_for')} <span className='headerMain'>{fullname}</span>
            </div>
            <div className='closeIcon' onClick={handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>

        <DialogContent style={{ height: '250px' }}>
          <Grid container item xs={12} className={classes.dialogContent}>
            <Grid item xs={10} sm={10} className={classes.selectPosition}>
              <FormControl fullWidth variant='outlined' className={classes.formControl}>
                <TextField
                  id='account'
                  name='account'
                  variant='outlined'
                  value={account}
                  size='small'
                  placeholder={t('choose_or_enter_account')}
                  className={classes.contentInput}
                  onChange={(e) => this.handleChangeAccount(e)}
                  onFocus={this.onFocusTextField}
                  InputProps={{
                    endAdornment: (
                      <div className={classes.iconButtonPosition}>
                        <Divider className={classes.dividerSearch} />
                        <IconButton
                          className={classes.iconDropDown}
                          onClick={this.onClickDropdown}
                          disabled={accountPatient.length > 0}
                        >
                          <KeyboardArrowDown />
                        </IconButton>
                      </div>
                    ),
                  }}
                  error={this.state.errorField.account.flag}
                  disabled={accountPatient.length > 0}
                />
                <FormHelperText error hidden={!this.state.errorField.account.flag} id='component-error-text'>
                  {t(`${this.state.errorField.account.msg}`)}
                </FormHelperText>
                {displayAccounts && accountList.length > 0 && (
                  <Paper className={classes.list}>
                    <div style={{ position: 'relative' }}>
                      <MenuList>
                        {accountList.map((account) => (
                          <MenuItem
                            key={account.id}
                            onClick={() => this.handleSelect(account)}
                            disabled={account.patientId ? true : false}
                          >
                            <Grid container>
                              <Grid container item sm={6} xs={6}>
                                <Typography>
                                  {account.devices && account.devices.length > 0
                                    ? account.username + ` (${this.getGarminDeviceInfo(account.devices)})`
                                    : account.username}
                                </Typography>
                              </Grid>

                              <Grid container item sm={6} xs={6} className={classes.contentData}>
                                {account.patient && (
                                  <Typography>
                                    {account.patient.firstname} {account.patient.lastname}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </div>
                  </Paper>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={2} sm={2}>
              <Button
                variant='outlined'
                color='primary'
                id='assign'
                className={classes.iconButton}
                onClick={() => this.onAssignAccount(patient)}
                disabled={!account}
              >
                <Icons.ControlPoint /> {t('assign')}
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <MUIDataTable
              data={accountPatient}
              columns={columns}
              searchable={false}
              options={{
                viewColumns: false,
                filter: false,
                sort: false,
                download: false,
                print: false,
                pagination: false,
                selectableRowsOnClick: false,
                selectableRows: 'none',
                searchable: false,
                search: false,
                responsive: 'scrollFullHeight',
                rowsPerPage: 5,
              }}
            />
          </Grid>
        </DialogContent>

        {/* <DialogActions>
          <Button onClick={handleClose} color="default" id="cancel">
            {t("close")}
          </Button>
        </DialogActions> */}
      </Dialog>
    );
  }
}
const styles = (theme) => ({
  dialogContent: {
    marginBottom: 10,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '98%',
    marginBottom: '10px',
    marginTop: '-5px',
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  iconButton: {
    width: '100%',
    marginTop: 2,
    padding: 6,
    height: 38,
  },
  selectPosition: {
    position: 'relative',
  },
  list: {
    position: 'absolute',
    width: '100%',
    maxHeight: '200px',
    overflow: 'scroll',
    zIndex: 200,
    marginTop: 50,
  },
  dividerSearch: {
    width: 1,
    height: 28,
    margin: 4,
  },
  iconDropDown: {
    width: 20,
    height: 20,
    marginTop: 8,
    marginLeft: 5,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  iconButtonPosition: {
    display: 'flex',
    backgroundColor: 'transparent !important',
    marginTop: 5,
  },
  tooltip: {
    fontSize: '16px',
  },
  icon: {
    marginLeft: 15,
  },
  contentData: {
    display: 'flex',
    alignItems: 'right',
    justifyContent: 'right',
  },
});
export const page = inject('smartwatch', 'garmin')(observer(ManageGarminAccount));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
